import React from 'react';
import { StatusBarStyle, StyleSheet } from 'react-native';
import { Avatar, Chip, Colors } from 'react-native-paper';
import { useNavigation } from '@react-navigation/native';
import { truncate } from 'lodash';
import styled from 'styled-components/native';

import { PlaceTag } from '@src/types';

const size = 34;
const borderRadius = size / 2;

const styles = StyleSheet.create({
  avatar: {
    borderRadius,
    height: size,
    width: size,
    backgroundColor: Colors.white,
  },
});

type Props = {
  barStyle?: StatusBarStyle;
  maxTextLength?: number;
  place?: PlaceTag;
};

const Component = styled(Chip).attrs<Props>(({ theme, barStyle }) => ({
  avatar: (
    <Avatar.Icon
      size={size}
      color={theme.colors.primary}
      icon="map-marker-alt"
      style={styles.avatar}
    />
  ),
  textStyle: {
    fontSize: 12,
    lineHeight: size,
    textAlignVertical: 'center',
    color:
      barStyle === 'dark-content'
        ? theme.colors.primary
        : theme.colors.onPrimary,
  },
}))<Props>`
  background-color: ${({ theme, barStyle }) =>
    barStyle === 'dark-content'
      ? theme.colors.onPrimary
      : theme.colors.primary};
  justify-content: center;
  height: ${size + 10}px;
  border-bottom-end-radius: 0;
  border-top-end-radius: 0;
  border-bottom-start-radius: ${borderRadius}px;
  border-top-start-radius: ${borderRadius}px;
`;

const LocationTag: React.FC<Props> = ({
  place,
  maxTextLength = 24,
  barStyle,
}) => {
  const navigation = useNavigation();
  const handlePress = React.useCallback(() => {
    if (place) {
      navigation.navigate('Location', { id: place.id });
    }
  }, [navigation, place]);

  if (!place) {
    return null;
  }

  return (
    <Component barStyle={barStyle} onPress={handlePress}>
      {truncate(place?.name, { length: maxTextLength })}
    </Component>
  );
};

export default React.memo(LocationTag);
